import { ActionButton } from "#/components/shared/buttons/ActionButtons";
import type { ReviewCard as ReviewCardType, ReviewHighlightTone } from "./reviewTypes";

function highlightClasses(tone: ReviewHighlightTone) {
  switch (tone) {
    case "terracotta":
      return {
        badge: "border-terracotta-200 bg-terracotta-50 text-terracotta-700",
      };
    case "brown":
      return {
        badge: "border-brown-200 bg-brown-50 text-brown-700",
      };
    default:
      return {
        badge: "border-beige-200 bg-beige-50 text-brown-600",
      };
  }
}

export type ReviewCardProps = {
  card: ReviewCardType;
  onEdit?: (card: ReviewCardType) => void;
  onDelete?: (card: ReviewCardType) => void;
};

export function ReviewCard({ card, onEdit, onDelete }: ReviewCardProps) {
  const tone = card.tone ?? "beige";
  const classes = highlightClasses(tone);

  return (
    <div
      data-review-note-id={card.id}
      className="rounded-xl border border-beige-200 bg-white p-4 shadow-sm"
    >
      <div className="flex flex-wrap items-center gap-2 text-xs text-brown-600">
        {card.status ? (
          <span
            className={`inline-flex items-center rounded-full border px-2 py-1 font-semibold ${classes.badge}`}
          >
            {card.status}
          </span>
        ) : null}
        {card.reviewerId ? <span>Reviewer: {card.reviewerId}</span> : null}
        {card.createdAt ? <span>Created: {card.createdAt}</span> : null}
      </div>
      <div className="mt-3 whitespace-pre-wrap text-sm text-brown-700">
        {card.notes?.trim() || "No notes for this review."}
      </div>
      {(onEdit || onDelete) ? (
        <div className="mt-4 flex flex-wrap gap-2">
          {onEdit ? (
            <ActionButton
              size="sm"
              tone="secondary"
              onClick={() => onEdit(card)}
            >
              Edit notes
            </ActionButton>
          ) : null}
          {onDelete ? (
            <ActionButton
              size="sm"
              tone="secondary"
              onClick={() => {
                if (!window.confirm("Delete this review?")) return;
                onDelete(card);
              }}
              isLoading={card.isDeleting}
            >
              Delete
            </ActionButton>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export default ReviewCard;
